import { render, staticRenderFns } from "./GoodbyeOnsCampaignPage.vue?vue&type=template&id=5475560e&scoped=true"
import script from "./GoodbyeOnsCampaignPage.vue?vue&type=script&lang=js"
export * from "./GoodbyeOnsCampaignPage.vue?vue&type=script&lang=js"
import style0 from "./GoodbyeOnsCampaignPage.vue?vue&type=style&index=0&id=5475560e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475560e",
  null
  
)

export default component.exports